/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

import * as React from "react";
import { createUseScreenVariants } from "@plasmicapp/react-web";

export type Segment2Value = "override";
export const Segment2Context = React.createContext<Segment2Value | undefined>(
  "PLEASE_RENDER_INSIDE_PROVIDER" as any
);
export function Segment2ContextProvider(
  props: React.PropsWithChildren<{ value: Segment2Value | undefined }>
) {
  return (
    <Segment2Context.Provider value={props.value}>
      {props.children}
    </Segment2Context.Provider>
  );
}

export function useSegment2() {
  return React.useContext(Segment2Context);
}

export default Segment2Context;
/* prettier-ignore-end */
